export enum ContactDisplayLayout {
    main = 'MAIN',
    aside = 'ASIDE',
}

export enum ContactDisplayAsideLayout {
    events = 'EVENTS',
    notes = 'NOTES',
    info = 'INFO',
    engage = 'ENGAGE',
}
